import { createRoute } from '@tanstack/react-router';
import { LeasingPrehledy } from '@/modules/leasing/LeasingPrehledy';
import type { PrehledReport } from '@/modules/leasing/api';
import { Route as RootRoute } from './__root';

interface PrehledySearch {
  report?: PrehledReport;
  mesic?: string;
}

const REPORT_VALUES = ['splatky', 'smlouvy-ukonceni', 'uvery', 'uvery-ukonceni'] as const;
const MESIC_RX = /^\d{4}-\d{2}$/;

function parsePrehledySearch(input: Record<string, unknown>): PrehledySearch {
  const out: PrehledySearch = {};
  const r = input.report;
  if (typeof r === 'string' && (REPORT_VALUES as readonly string[]).includes(r)) {
    out.report = r as PrehledReport;
  }
  const m = input.mesic;
  if (typeof m === 'string' && MESIC_RX.test(m)) out.mesic = m;
  return out;
}

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/leasing/prehledy',
  component: LeasingPrehledy,
  validateSearch: parsePrehledySearch,
});
